module.exports = __webpack_public_path__ + "img/action-white.fb24d4d2.svg";